import {HttpResponse, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {saveAs} from 'file-saver';
import {catchError} from 'rxjs/operators';
import {ErrorHandlingHttpClient} from '../../shared/services/error-handling-http-client.service';
import {UtilsService} from '../../shared/services/utils.service';
import {EMPTY} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {
  constructor(private errorHandlingHttp: ErrorHandlingHttpClient) {}

  public getFileBlob(url: string, payload?: any): Promise<[Blob, HttpHeaders]> {
    return new Promise((resolve, reject) => {
      const options = {
        observe: 'response',
        responseType: 'blob'
      };

      const http$ = payload
        ? this.errorHandlingHttp.post<HttpResponse<Blob>>(url, payload, options)
        : this.errorHandlingHttp.get<HttpResponse<Blob>>(url, options);
      http$
        .pipe(
          catchError(e => {
            reject(e);
            return EMPTY;
          })
        )
        .subscribe(resp => {
          resolve([resp.body, resp.headers]);
        });
    });
  }
  public static getFileNameFromContentDispostion(disposition: string): string {
    const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-.]+)(?:; ?|$)/i;
    const asciiFilenameRegex = /^filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;

    let fileName: string = null;
    if (utf8FilenameRegex.test(disposition)) {
      fileName = decodeURIComponent(utf8FilenameRegex.exec(disposition)[1]);
    } else {
      // prevent ReDos attacks by anchoring the ascii regex to string start and
      //  slicing off everything before 'filename='
      const filenameStart = disposition.toLowerCase().indexOf('filename=');
      if (filenameStart >= 0) {
        const partialDisposition = disposition.slice(filenameStart);
        const matches = asciiFilenameRegex.exec(partialDisposition);
        if (matches != null && matches[2]) {
          fileName = matches[2];
        }
      }
    }
    return fileName;
  }

  public downloadFile(url: string, fileName?: string, payload?: any): void {
    const options = {
      observe: 'response',
      responseType: 'blob'
    };

    const http$ = payload
      ? this.errorHandlingHttp.post<HttpResponse<Blob>>(url, payload, options)
      : this.errorHandlingHttp.get<HttpResponse<Blob>>(url, options);
    http$.subscribe(resp => {
      const name = this.getFileNameFromHeader(resp) || fileName || this.getFileNameFromUrl(url);
      saveAs(resp.body, name);
    });
  }

  private getFileNameFromHeader(resp: HttpResponse<any>): string {
    return resp.headers.has('file-name') ? UtilsService.getFileNameFromHeaders(resp.headers) : null;
  }

  private getContentTypeFromHeader(resp: HttpResponse<any>): string {
    return resp.headers.get('Content-Type') || 'application/octet-stream';
  }

  private getFileNameFromUrl(url: string): string {
    url = decodeURIComponent(url);
    const base = url.split('?')[0];
    const components = base.split('/');
    // fileName
    return components[components.length - 1];
  }
}
